<template>
    <li>
        <a class="dropdown-item text-xs" :class="{ 'disabled': disabled }" href="#" @click.prevent="clickMethod()" v-bind="props" @confirm="confirmMethod()">
            <Icon :icon="icon" v-if="icon" class="me-1" /><slot></slot>
        </a>
    </li>
</template>

<script>
    import Icon from '../Icons/Icon'

    export default {
        name: 'DropdownItem',
        components: { Icon },
        props: {
            closeOnClick: {
                type: Boolean,
                default: true
            },
            confirm: Boolean,
            disabled: Boolean,
            icon: [ String, Array ],
            title: String,
            text: String
        },
        computed: {
            props: function() {
                return this.confirm ? {
                    'is': "confirm",
                    'tag': "a",
                    'title': this.title,
                    'text': this.text
                } : {}
            }
        },
        methods: {
            clickMethod() {
                if(!!this.$parent && this.closeOnClick) this.$parent.close()
                this.$emit('click')
            },
            confirmMethod() {
                this.$emit('confirm')
            }
        }
    }
</script>